import styled from "styled-components"

export const TableWrapper = styled.section`
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  padding-top: 16px;
`